
export default {
  name: "CollectionCard",
  props: {
    collection: {
      type: Object,
      required: true,
    },
    large: {
      type: Boolean,
      default: false,
    },
    imagePosition: {
      type: String,
      default: "",
    },
    useLazyLoad: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    image() {
      return this.collection.medias?.find(
        (el) => el.position === this.imagePosition
      );
    },
  },
};
